// Is this component still being used??
import React from 'react';
import ReactTooltip from 'react-tooltip';
import { sanitizedData } from '../../../helper_functions/sanitizeData';
import { HelpCircle } from 'Utils/SvgIcons';
import AddOnReservedOrdersModal from '../calendar/AddOnReservedOrdersModal';

class MultilocationSummary extends React.Component {
  render() {
    const { product } = this.props;
    let groupSharedQuantity = 0;
    if (product.groupInfo) {
      groupSharedQuantity = product.groupInfo.sharedInventory.reduce(
        (sum, sharedProduct) => (sum += sharedProduct.quantity),
        0
      );
    }

    const quantity =
      product.productType === 'addons'
        ? product.ownedQuantity ?? 0
        : product.rentableQuantity;
    const quantityClassName = quantity < 0 ? 'orange-color' : undefined;
    const quantityInWarehouseClassName = product.quantityInWarehouse < 0 ? 'orange-color' : undefined;
    const tooltipId = `multilocation-summary-info-${product.token}`;
    const reservedPendingCheckoutTooltipId = `multilocation-summary-reserved-pending-${product.token}`;
    const isAddOn = product.productType === 'addons';

    const renderReservedPendingCheckoutColumn = () => (
      <AddOnReservedOrdersModal
        addOnToken={product.token}
        reservedQuantity={product.reservedQuantity ?? 0}
        tooltipId={reservedPendingCheckoutTooltipId}
      />
    );

    const renderInWarehouseQuantityColumn = () => (
      <div className='addonQuantityColumn'>
        <p>
          <strong>In warehouse</strong>
        </p>
        <br />
        <label className={quantityInWarehouseClassName}>{product.quantityInWarehouse ?? 0}</label>
      </div>
    );

    return (
      <div className='summaryInfo'>
        <strong>{product.name}</strong>
        <p dangerouslySetInnerHTML={sanitizedData(product.description)} />
        {product.groupInfo ? (
          <>
            <p className='multilocationQuantityLabels'>
              <label className='caption'>This Location</label>
              <label className='caption'>(All Locations)</label>
              <a
                className='info'
                data-tip
                data-for={tooltipId}
                data-event='mouseenter'
                data-event-off='mouseleave'
              >
                <HelpCircle />
              </a>
              <ReactTooltip
                id={tooltipId}
                className='tooltip left'
                place='right'
                effect='solid'
              >
                <p>
                  Quantity numbers are shown for both this location and all
                  locations. Quantities for all locations are shown inside the
                  parenthesis.
                </p>
              </ReactTooltip>
            </p>
            <label className='multilocationQuantityValues'>
              {quantity}
              <span>({groupSharedQuantity})</span>
            </label>
            {isAddOn && (
              <div className='addonQuantityColumns'>
                {renderReservedPendingCheckoutColumn()}
                {renderInWarehouseQuantityColumn()}
              </div>
            )}
          </>
        ) : isAddOn ? (
          <div className='addonQuantityLayout'>
            <div className='addonQuantityRow addonQuantityRow--owned'>
              <p>
                <strong>Quantity Owned</strong>
              </p>
              <label className={quantityClassName}>{quantity}</label>
            </div>
            <div className='addonQuantityRow addonQuantityColumns'>
              {renderReservedPendingCheckoutColumn()}
              {renderInWarehouseQuantityColumn()}
            </div>
          </div>
        ) : (
          <>
            <label className={quantityClassName}>{quantity}</label>
          </>
        )}
        {product.buffer > 0 && (
          <div className='buffer'>
            <h6>Buffer</h6>
            <span>
              {Math.round(
                (product.productType === 'addons'
                  ? product.quantityInWarehouse ?? 0
                  : product.quantity) * (product.buffer / 100)
              )} (
              {product.buffer}
              %)
            </span>
          </div>
        )}
        {product.groupInfo && (
          <div className='groupItems'>
            <strong>Other Location Quantities</strong>
            {product.groupInfo.sharedInventory.map(
              (sharedProduct, index) =>
                sharedProduct.id !== product.id && (
                  <div key={index}>
                    <strong>{sharedProduct.quantity}</strong>
                    {sharedProduct.locationName}
                    {sharedProduct.locationCode &&
                      ' (' + sharedProduct.locationCode + ')'}
                  </div>
                )
            )}
          </div>
        )}
      </div>
    );
  }
}

export default MultilocationSummary;
